import React, { Component, PropTypes } from 'react';
export class MaxLimitFriendPage extends Component {
  constructor(props) {
    super(props);
  }

  handleCloseWindow() {
    if (window.opener) {
      if (window.__BROWSER_NAME__ === "Mobile Safari") {
        const open = window.open(',', '_self');
        if (open) {
          open.close();
        }
      }
    }
    window.close();
  }

  render() {
    const { device } = this.props;

    const RenderMultiElement = () => [
      <div id="kakaoHead" className="head_bridge" role="banner" key="header">
        <h1 className="tit_logo">
          <a href="#none" className="link_logo" style={{ padding: 0 }}>
            <span className="ico_plus ico_logo">카카오톡 채널</span>
          </a>
        </h1>
      </div>,
      <hr className="hide" key="hidden_line" />,
      <div id="kakaoContent" className="cont_bridge" role="main" key="content">
        <span className="img_404" />
        <strong className="tit_bridge">친구 추가 실패</strong>
        <p className="desc_bridge">더 이상 채널을 추가할 수 없습니다.<br />채널은 2,000명까지 추가 가능합니다.</p>
        <a id="cancel_btn" className="btn_bridge" style={{ cursor: 'pointer' }} onClick={this.handleCloseWindow}>확인</a>
        <div className="logout_bridge">
          <a href={`${process.env.REACT_APP_KAKAO_ACCOUNT_URL}/logout?continue=${process.env.REACT_APP_SERVICE_HOST}/logged_out`}
            className="link_logout"
          >
            로그아웃
          </a>
        </div>
      </div>
    ];
    return (<RenderMultiElement />);
  }
}

export default MaxLimitFriendPage;



// WEBPACK FOOTER //
// ./src/containers/MaxLimitFriendPage/index.js